import { render, staticRenderFns } from "./TwitchChat.vue?vue&type=template&id=3d8d60e4&"
import script from "./TwitchChat.vue?vue&type=script&lang=js&"
export * from "./TwitchChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports